/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_Default_BadgeInputs */

const en_checkout_default_badge = /** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const es_checkout_default_badge = /** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predeterminado`)
};

const fr_checkout_default_badge = /** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut`)
};

const de_checkout_default_badge = /** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const id_checkout_default_badge = /** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utama`)
};

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const ja_checkout_default_badge = en_checkout_default_badge;

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const zh_checkout_default_badge = en_checkout_default_badge;

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const ar_checkout_default_badge = en_checkout_default_badge;

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const it_checkout_default_badge = en_checkout_default_badge;

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const ru_checkout_default_badge = en_checkout_default_badge;

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const pt_checkout_default_badge = en_checkout_default_badge;

/** @type {(inputs: Checkout_Default_BadgeInputs) => LocalizedString} */
const ko_checkout_default_badge = en_checkout_default_badge;

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Checkout_Default_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const checkout_default_badge = /** @type {((inputs?: Checkout_Default_BadgeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_Default_BadgeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkout_default_badge(inputs)
	if (locale === "es") return es_checkout_default_badge(inputs)
	if (locale === "fr") return fr_checkout_default_badge(inputs)
	if (locale === "de") return de_checkout_default_badge(inputs)
	if (locale === "ja") return ja_checkout_default_badge(inputs)
	if (locale === "zh") return zh_checkout_default_badge(inputs)
	if (locale === "ar") return ar_checkout_default_badge(inputs)
	if (locale === "id") return id_checkout_default_badge(inputs)
	if (locale === "it") return it_checkout_default_badge(inputs)
	if (locale === "ru") return ru_checkout_default_badge(inputs)
	if (locale === "pt") return pt_checkout_default_badge(inputs)
	return ko_checkout_default_badge(inputs)
});